import { Link, Navigate, useParams } from "react-router-dom";
import Navbar from "../features/Navbar/Navbar";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { emptyCurrentOrder } from "../features/order/orderSlice";
import { resetCartAsync } from "../features/Cart/CartSlice";
import { selectLoggedInUser } from "../features/Auth/authSlice";
import { toast } from "react-hot-toast";

export default function OrderSuccess() {
  const params = useParams();
  const user = useSelector(selectLoggedInUser);
  const dispatch = useDispatch();
  useEffect(() => {
    toast.success('Order Successfully placed')
    dispatch(resetCartAsync(user.id));
    dispatch(emptyCurrentOrder());
  }, [user.id,dispatch]);
  return (
    <>
      {!params.id && <Navigate to="/"></Navigate>}
      <Navbar></Navbar>
      <main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
        <div className="text-center">
          <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-3xl">
            Hurray ! Your Order SuccessFully Placed
          </h1>
          <p className="mt-6 text-base leading-7 text-gray-600">
            Order ID : #{params.id}
          </p>
          <div className="mt-10 flex flex-col gap-5 sm:gap-0 sm:flex-row items-center justify-center gap-x-6">
            <Link
              to="/"
              className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Continue Shopping
            </Link>
            <Link
              to="/orders"
              className="rounded-md text-indigo-600 px-3.5 py-2.5 text-sm font-semibold focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
            >
              My Account {"->"} Orders
            </Link>
          </div>
        </div>
      </main>
    </>
  );
}
